<template>
  <div class="base-range">
    <input
      :value="modelValue"
      class="base-range__input"
      :type="'range'"
      :max="max"
      :min="min"
      @input="onInput"
      :style="{
        background: `linear-gradient(to right, #1390e5cc ${isRangeValue}%, #d5d5d5 ${isRangeValue}%), var(--background-primary)`,
      }"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
const props = defineProps({
  modelValue: {
    // Accept both number and string for compatibility; coerce internally
    type: [Number, String],
    default: 0,
  },
  max: {
    type: Number,
    default: 50,
  },
  min: {
    type: Number,
    default: 1,
  },
});
const isRangeValue = computed(() => {
  const current = Number(props.modelValue) || 0;
  const max = Number(props.max) || 1;
  return (current / max) * 100;
});

/**
 * @param {Event} e
 */
const onInput = (e) => {
  const target = e.target;
  // Narrow target to HTMLInputElement to access .value safely
  const input = target && 'value' in target ? /** @type {HTMLInputElement} */ (target) : null;
  const raw = input?.value ?? '0';
  const value = Number(raw);
  // Emit numeric value for range input
  // @ts-ignore - Vue macro typing for emit in JS
  $emit('update:modelValue', Number.isNaN(value) ? 0 : value);
};
</script>

<style lang="scss" scoped>
.base-range {
  width: 100%;
  &__input {
    position: relative;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    display: block;
    color: #1390e5cc;
    background: rgba(23, 23, 25, 0.3);
    border-radius: 3px;
    outline: none;
    width: 100%;
    height: 6px;

    &::-webkit-slider-runnable-track {
      -webkit-appearance: none;
      height: 8px;
    }

    &::-moz-track {
      -moz-appearance: none;
      height: 8px;
    }

    &::-ms-track {
      appearance: none;
      height: 8px;
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      height: 20px;
      width: 20px;
      border: 2px solid #1390e5;
      border-radius: 50%;
      cursor: grab;
      margin-top: -6px;
      background: var(--foreground-primary);
    }

    &::-moz-range-thumb {
      -moz-appearance: none;
      height: 20px;
      width: 20px;
      border: 2px solid #1390e5;
      border-radius: 50%;
      cursor: grab;
      margin-top: -6px;
      background: var(--foreground-primary);
    }
    &::-ms-thumb {
      appearance: none;
      height: 20px;
      width: 20px;
      border: 2px solid #1390e5;
      border-radius: 50%;
      cursor: grab;
      margin-top: -6px;
      background: var(--foreground-primary);
    }

    &:active::-webkit-slider-thumb {
      background-color: var(--foreground-primary);
      border: 2px solid #1390e5;
      cursor: grabbing;
    }
  }
}
</style>
